import React, { useEffect, useState } from 'react'
import { connectHits, Stats } from 'react-instantsearch-dom'

import Heading from '../../atoms/Search/Heading'

const Header = ({ hits }) => {
  const [showHeader, setShowHeader] = useState(true)

  useEffect(() => {
    if (window.location.search.match(/noheader/)) setShowHeader(false)
  }, [])

  return showHeader ? (
    <>
      {hits.length > 0 ? (
        <Heading>Apartments near {hits[0].market[0].split(' > ')[1]}</Heading>
      ) : null}
      <Stats
        translations={{
          stats: totalHits => (
            <p>
              {totalHits ? `Viewing ${hits.length} of ${totalHits} apartments` : 'No results found'}
            </p>
          ),
        }}
      />
    </>
  ) : null
}

export default connectHits(Header)
